import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Stack
} from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';

function PremiumResultCard({ label, value, isData }) {
  return (
    <Box mt={3}>
      {isData && value && (
        <Card
          elevation={6}
          sx={{
            maxWidth: 620,
            margin: '0 auto',
            borderRadius: 3,
            background: 'linear-gradient(120deg, #fff 70%, #f0f4ff 100%)',
            boxShadow: '0 2px 14px 0 rgba(45, 105, 215, 0.13)',
            p: 2
          }}
        >
          <CardContent>
            <Stack spacing={1}>
              <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700, letterSpacing: 1 }}>
                {label}
              </Typography>
              {/* Render each field */}
              {Object.entries(value).map(([key, val]) => (
                <Stack direction="row" spacing={2} key={key} alignItems="center">
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 90, fontWeight: 500 }}>
                    {key.replace(/_/g, ' ').toUpperCase()} :
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 800, color: "#E64833" }}>
                    {val}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}

export default function OrderDetails() {
  const [input, setInput] = useState('');
  const [isData, setIsData] = useState(false);
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false); // optional for UX
  const [error, setError] = useState('');


  const trackOrder = () => {
    setIsData(false);
    console.log(input);
    if (!input.trim()) {
      setError('Please enter tracking id..');
      setIsData(false);
      return;
    }
    setLoading(true);
    setError('');
      axios.post("https://oms-be.shreetradingcompany.in/api/track/",
        {
            tracking_id : input.trim()
        },
        {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }).then((res) => {
        setResult(res.data);
        setIsData(true);
        setLoading(false);
      },(error) => {
        console.log(error.response.data)
        setResult(error.response.data);
        setIsData(true);
        setLoading(false);
        toast.error(error.response.data.error_message)
      });
    };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(input);
    if (!input.trim()) {
      setError('Input cannot be empty');
      setIsData(false);
      return;
    }
    setLoading(true);
    setError('');
    
    // Replace this URL with your actual API endpoint
    axios.post('https://example.com/api/submit', { input: input.trim() })
      .then(response => {
        // Assume the API returns an object with a "message" property
        setResult(response.data.message || 'Success');
        setIsData(true);
      })
      .catch(err => {
        setError('Failed to submit data. Please try again.');
        setIsData(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 480,
        m: '40px auto',
        borderRadius: 2,
        background: 'linear-gradient(105deg,#eef3fa, #f9fcff 90%)',
        boxShadow: '0 4px 16px 0 #cdd7ee6b'
      }}
    >
      <form>
        <Stack direction="row" spacing={4} alignItems="center">
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter tracking id..."
            value={input}
            onChange={e => setInput(e.target.value)}
            InputProps={{
              sx: { borderRadius: 1, background: '#fff', fontWeight: 500 }
            }}
            disabled={loading}
          />
          <Button onClick={trackOrder} title="Track" variant="outlined">Track</Button>
        </Stack>
      </form>

      {error && (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {error}
        </Typography>
      )}

      <PremiumResultCard
        // label="Result"
        value={result}
        isData={isData}
      />
    </Box>
  );
}
